import { getSessionAuthentication, rms2BasePath } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T | null> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface Account {
    id: number;
    accountNumber: string;
    accountName: string;
}

export interface PaymentType {
    id: number;
    paymentTransactionCode?: string;
    paymentTransactionTypeName?: string;
    account: Account | null;
}

export async function getPaymentType(id: number): Promise<PaymentType> {
    const result = await rms2Fetch<PaymentType>(`paymenttypes/${id}`);
    if (!result) throw new Error('Empty response for getPaymentType');
    return result;
}

export async function updatePaymentType(paymentType: PaymentType): Promise<PaymentType> {
    const result = await rms2Fetch<PaymentType>(`paymenttypes/${paymentType.id}`, {
        method: 'PUT',
        body: JSON.stringify({ accountId: paymentType.account?.id })
    });
    if (!result) throw new Error('Empty response for updatePaymentType');
    return result;
}

export async function getAccounts(): Promise<Account[]> {
    const response = await rms2Fetch<{ accounts: Account[] }>('accounts');
    return response?.accounts ?? [];
}
